/**
 * @desc 分页
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(params: API.srm.changeApproval.page.Params, options?: any) {
  return updateResponse(
    http(URL + `/srm/changeApproval/page`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
